<template>
<div class="chat-body">
  <div class="search-wrap">
    <el-select size="mini" v-model="msgType" placeholder="消息类型" clearable style="width: 110px;">
      <el-option v-for="item in msgTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <el-select size="mini" v-model="regionId" filterable placeholder="选择战区" clearable>
      <template  v-for="item in regionList">
        <el-option :key="item.value" :label="item.label" :value="item.value" />
        <template v-if="item.children && item.children.length > 0">
          <el-option v-for="item2 in item.children" :key="item2.value" :label="' - ' + item2.label" :value="item2.value" />
        </template>
      </template>
    </el-select>
    <el-select size="mini" v-model="projectId" filterable placeholder="选择项目" clearable>
      <el-option v-for="item in projectListFilter" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <el-select size="mini" v-model="chatId" filterable placeholder="选择群" clearable>
      <el-option v-for="item in GroupListFilter" :key="item.chat_id" :label="item.name" :value="item.chat_id"></el-option>
    </el-select>
    <el-date-picker size="mini" v-model="dateSpan" type="datetimerange" align="right" value-format="yyyy-MM-dd HH:mm:ss" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" style="width: 300px">
    </el-date-picker>
    <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
    <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
  </div>
  <div class="table-wrap-c">
    <el-table v-loading="loading" class="chat-table" :data="tableData" :height="__TABLE_HEIGHT__">
      <el-table-column label="会话类型" width="80" align="left">
        <template slot-scope="scope">
          <el-tag :type="getTagType(scope.row.msgtype)" size="small">{{ getMsgTypeName(scope.row.msgtype) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="发送方" align="center">
        <template slot-scope="scope">
          <i class="el-icon-user-solid" v-if="scope.row.from_is_internal"></i><i class="el-icon-user" v-else></i><span style="margin-left: 3px">{{ scope.row.from }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目" align="center">
        <template slot-scope="scope">
          <el-tag size="" v-if="scope.row.project_name">{{scope.row.project_name}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="接收方" align="center">
        <template slot-scope="scope">
          <a href="javascript:;" v-if="scope.row.roomid" @click="showMemberList(scope.row.roomid)">{{scope.row.room_name}}</a>
          <span v-else><i :class="[scope.row.tolist_is_internal ? 'el-icon-user-solid' : 'el-icon-user']"></i> {{ scope.row.tolist }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发送时间">
        <template slot-scope="scope">
          <i class="el-icon-time"></i><span style="margin-left: 3px">{{ scope.row.msgtime }}</span>
        </template>
      </el-table-column>

      <el-table-column label="内容" >
        <template slot-scope="scope">
          <el-popover v-if="scope.row.msgtype === 'text'" width="500" placement="top-start" title="内容" trigger="click" :content="scope.row.text">
              <span slot="reference" v-html="shortText(scope.row.text)"></span>
          </el-popover>
          <el-image class="chat-image" fit="cover" :src="getFilePath(scope.row.path)" :preview-src-list="pathList" v-if="scope.row.msgtype == 'image'"></el-image>
          <el-link icon="el-icon-download" :href="getFilePath(scope.row.path)" v-if="scope.row.msgtype == 'voice'" target="_blank" type="primary">下载</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, pager, next" :total="total" :current-page="page" :page-size="pageSize" @current-change="currentChange"></el-pagination>
    </div>


    <el-dialog title="成员列表" :visible.sync="dialogTableVisible" width="1000px">
      <el-table :height="__TABLE_HEIGHT__" v-loading="memberLoading" :data="memberList" width>
        <el-table-column label="类型" width="110">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.type == 1 ? 'primary' : 'info'">{{ typeList[scope.row.type]}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column property="name" label="姓名" width="100"></el-table-column>
        <el-table-column property="group_nickname" label="群昵称" width="100"></el-table-column>
        <el-table-column property="join_time" label="入群时间" width="200"></el-table-column>
        <el-table-column property="join_scene" label="入群方式" width=""></el-table-column>
        <el-table-column property="invitor" label="邀请者" width="200"></el-table-column>
      </el-table>
    </el-dialog>

  </div>
</div>
</template>

<script>

  import { Loading } from 'element-ui';

export default {
  name: "ConversationChat",
  data () {
    return {
        keyword: '',
        pathList: [],
        tableData: [],
        page: 1,
        total: 0,
        pageSize: 10,
        loading: false,
        msgType: '',
        msgTypeList: [
          {label: '文本', value: 'text'},
          {label: '图片', value: 'image'},
          {label: '语音', value: 'voice'}
        ],
        pickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dateSpan: '',
        regionId: '',
        regionList: [],
        projectId: '',
        projectList: [],
        projectListFilter: [],
        chatId: '',
        GroupList: [],
        GroupListFilter: [],
        dialogTableVisible: false,
        memberList: [],
        memberLoading: false,
        typeList: {
          1: "企业成员",
          2: "外部联系人"
        },
        joinScineList: {
          1: "由群成员邀请入群（直接邀请入群）",
          2: "由群成员邀请入群（通过邀请链接入群）",
          3: "通过扫描群二维码入群"
        }
    }
  },
  //界面没出来前加载
  created() {
    this.getRegionList()
    this.getProjectList()
    this.getGroupList()
    //this.getChatList()
  },
  watch:{
    '$route'(to, from){
      if(to.path == '/Conversation/Chat') {
        this.checkRouter()
      }
    },
    regionId(val) {
      this.onRegionChange(val)
    },
    projectId(val) {
      this.onProjectChange(val)
    }
  },
  computed:{
    __TABLE_HEIGHT__(){
      return (window.outerHeight - 350) + 'px'
    }
  },

  //事件
  methods: {
    getChatList() {
      const that = this
      that.loading = true
      let date_start = ''
      let date_end = ''
      if(that.dateSpan && that.dateSpan != null) {
        date_start = that.dateSpan[0]
        date_end = that.dateSpan[1]
      }
      this.$qwhttp.get('chat_list', {params: {project_id: this.getProjectIds(), room_id: this.chatId, keyword: this.keyword, msgtype: this.msgType,  page: this.page, page_size: this.pageSize, date_start: date_start, date_end: date_end}}).then( res => {
        if(res.status == 200) {
          let newPathList = []
          if(res.data.data != null) {
            res.data.data.forEach( item => {
              if(item.msgtype == 'image') newPathList.push(that.getFilePath(item.path))
            })
            res.data.data = res.data.data.map(item => {
              item.msgtime = that.dateFormat(item.msgtime / 1000)
              if(item.roomid != "") {
                item.tolist = item.tolist.split(',')
              }
              //if(item.department) item.department = item.department.map(item => item.reverse().join(' - '))
              return item
            })
          }
          that.pathList = newPathList
          that.tableData = res.data.data
          that.total = res.data.total
        }
        that.loading = false
      });
    },
    getProjectIds() {
      if(this.projectId) {
        return this.projectId
      } else {
        return this.projectListFilter.map(item => item.value).join(',')
      }
    },
    getFilePath(path) {
      //return 'http://192.168.100.149:8100/' + path
      return 'https://qw.51homemoney.com/' + path
    },
    dateFormat(timestamp = 0, displayTime = true) {
    	let date = timestamp > 0 ? new Date(timestamp * 1000) : new Date();
    	let year = date.getFullYear();
    	let month = ("0" + (date.getMonth() + 1)).slice(-2);
    	let sdate = ("0" + date.getDate()).slice(-2);
    	let hour = ("0" + date.getHours()).slice(-2);
    	let minute = ("0" + date.getMinutes()).slice(-2);
    	let second = ("0" + date.getSeconds()).slice(-2);
    	let result = year + "-" + month + "-" + sdate;
    	if(displayTime) result += " " + hour + ":" + minute + ":" + second
    	return result
    },
    getMsgTypeName(msgtype) {
      switch(msgtype) {
        case 'text' : return '文本';
        case 'image' : return '图片';
        case 'voice' : return '语音';
        default: msgtype
      }
    },
    getTagType(type) {
      switch(type) {
        case 'text' : return 'primary';
        case 'image' : return 'warning';
        case 'voice' : return 'info';
        default: 'primary'
      }
    },
    currentChange(page) {
      this.page = page
      this.getChatList()
    },
    search() {
      this.page = 1
      this.getChatList()
    },
    shortText(text) {
      let newText = text.length > 50 ? '<a href="javascript:;">' + text.substr(0, 50) + '...</a>' : text
      return newText
    },
    parseTag(text) {
      let arr = text.split(',')
      let ret = ""
      for(let k in arr) {
        ret += "<el-tag>"+ arr[k] +"</el-tag>"
      }
      return ret
    },
    searchRoom(roomid) {
      this.$router.push('/Conversation/GroupChat');
    },
    getProjectList() {
      this.$qwhttp.get('project/options', {}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.projectList = res.data.data
          this.projectListFilter = res.data.data
          this.checkRouter()
        }
      })
    },
    getRegionList() {
      this.$qwhttp.get('region/options', {}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.regionList = this.getRegionTree(0, res.data.data)
        }
      })
    },
    getRegionTree(id, d) {
      let list = []
      for(const k in d) {
        if(d[k].parent_id == id) {
          let item = d[k]
          item.children = this.getRegionTree(item.value, d)
          list.push(item)
        }
      }
      return list
    },
    onRegionChange(val) {
      this.projectListFilter = val ? this.projectList.filter(item => {
        return item.region_id == val
      }) : this.projectList
      this.projectId = ''
    },
    onProjectChange(val) {
      this.GroupListFilter = val ? this.GroupList.filter(item => {
        return item.project_id == val
      }) : this.GroupList
      this.chatId = ''
    },
    getGroupList() {
      this.$qwhttp.get('group/options', {}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.GroupList = res.data.data
          this.GroupListFilter = res.data.data
        }
      })
    },
    showMemberList(chat_id) {
      const that = this
      that.dialogTableVisible = true
      that.memberLoading = true
      that.$qwhttp.get('group/members', {params: {chat_id: chat_id}}).then( res => {
        if(res.status == 200) {
          if(res.data.data != null ) {
            res.data.data.map(item => {
              item.join_time = that.dateFormat(item.join_time)
              item.join_scene = that.joinScineList[item.join_scene]
              return item
            })
          }
          that.memberList = res.data.data
        }
         that.memberLoading = false
      });

    },

    checkRouter() {
      const query = this.$route.query

      //this.msgType = 'text'
      this.keyword = query.keyword ? query.keyword : ''
      this.projectId = query.project_id ? Number(query.project_id) : ''
      this.chatId = query.room_id ? query.room_id : ''

      if(query.start_date && query.end_date) {
        this.dateSpan = [query.start_date, query.end_date]
      } else {
        this.dateSpan = []
      }

      this.search()
    }

  }
}
</script>
<style scoped lang="scss">
.chat-body{
  box-sizing: border-box;
  position: relative;
  padding: 15px;
}

.text2 {
  color: #FFFFFF;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
  align-items: center;

  > * {
    margin-right: 5px
  }
}

.table-wrap-c {
  margin-top: 5px;
}

.pagination {
  display: flex;
  padding: 15px 0;
  justify-content: center;
}

.chat-table {
  box-sizing: border-box;
}

.chat-image {
  width: 70px;
  height: 70px;
  border-radius: 3px;
  box-shadow: 0 0 5px #cccccc8a;
  padding: 2px;
  margin-top: 3px;
  background: #fff;
}
.to-list-item {
  margin-right: 3px;
  margin-bottom: 3px;
}

.kw {
  background: #FFFF00;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Conversation/Chat.vue